import { THarvestBatch } from './isHarvestBatch';

function harvestBatchFieldName<TGenericHarvestBatch>(
	harvestBatch: TGenericHarvestBatch & Pick<THarvestBatch, 'field'>
): string {
	return harvestBatch.field.name || '';
}

export default harvestBatchFieldName;
